const HTML_PARAGRAPH_PATTERN = '<p>((?:.|\n)*?)</p>';

const HTML_PARAGRAPH_REG_EXP_GLOBALLY = new RegExp(HTML_PARAGRAPH_PATTERN, 'g');

/**
 * заменяет  тег 'p' и 'br' на \n
 * @param html string
 * @returns string
 */
export const cleanFromParagraphsAndBr = (html: string): string => {
  return html
    .replace(HTML_PARAGRAPH_REG_EXP_GLOBALLY, '$1\n')
    .replace(/<br>/g, '\n')
    .trim();
};
